import { Media } from '@/src/models/MeidaDto';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const testFormSchema = () => {
  return z.object({
    text: z.string().min(1, '에러입니다'),
    radio: z.string(),
    select: z.string().min(1, '에러입니다'),
    'select&input': z.string().min(1, '에러입니다'),
    'select&input2': z.string().min(1, '에러입니다'),
    media: z
      .object({
        bufferFullUrl: z.string().min(1),
      })
      .nullable(),
    media2: z.array(
      z.object({
        bufferFullUrl: z.string().min(1),
      }),
    ),
    date: z.string().min(1, '에러입니다'),
  });
};

export const testFormResolver = () => zodResolver(testFormSchema());

export const testDefaultValues: {
  text: string;
  radio: string;
  select: string;
  'select&input': string;
  'select&input2': string;
  media: Media | null;
  media2: Media[];
  date: string;
} = {
  text: '',
  radio: 'true',
  select: '',
  'select&input': 'test2',
  'select&input2': 'test2',
  media: null,
  media2: [],
  date: '',
};
